import React from 'react';
import PropTypes from 'prop-types';
import IconCaret from '../../icons/icon-caret.svg';


const modifierMap = {
  default: 'default',
  form: 'form',
  commoditySwitcher: 'switcher',
  resultsGrid: 'results-grid',
};
/*
  Stubbed out component, we will need to build a custom dropdown

  TODO:
    - Replace <select> & <option> with customizable elements
    - Add a hidden <input> to track selection
    - Handle basic keyboard functionality
    - Style/provide themeability
*/

const Dropdown = function DropdownComponent(props) {
  const {
    theme,
    options,
    onChange,
    fieldName,
    selectedValue,
    disabledMsg,
    inputDescribedBy,
    inputLabelledBy,
  } = props;
  const modifierClass = modifierMap[theme] ? `dropdown--${modifierMap[theme]}` : '';
  const wrapperModifierClass = modifierMap[theme] ? `dropdown__wrapper--${modifierMap[theme]}` : '';

  const OptionsMap = ({ options, disabledMsg }) => options.map((option) => {
    const disabled = option.disabled === true;

    return (
      <option
        key={option.value}
        value={option.value}
        disabled={disabled}
      >
        {option.label}
        {disabled && `   ${disabledMsg}`}
      </option>
    );
  });

  return (
    <label
      className={`dropdown__wrapper ${wrapperModifierClass}`}
      htmlFor={fieldName}
    >
      <select
        className={`dropdown ${modifierClass}`}
        id={fieldName}
        name={fieldName}
        onChange={onChange}
        value={selectedValue}
        aria-describedby={inputDescribedBy}
        aria-labelledby={inputLabelledBy}
      >
        <OptionsMap options={options} disabledMsg={disabledMsg} />
      </select>
      <IconCaret className="dropdown__icon" />
    </label>
  );
};

Dropdown.propTypes = {
  theme: PropTypes.string,
  disabledMsg: PropTypes.string,
  fieldName: PropTypes.string,
  selectedValue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  inputDescribedBy: PropTypes.string,
  inputLabelledBy: PropTypes.string,
};

Dropdown.defaultProps = {
  theme: 'default',
  fieldName: '',
  selectedValue: '',
  disabledMsg: '',
  inputDescribedBy: null,
  inputLabelledBy: null,
};

export default Dropdown;
